import { useState } from "react";

const faqs = [
  {
    q: "Is this program suitable for complete beginners?",
    a: "Absolutely. The Harambee Trading Academy is specifically designed with beginners in mind. Our curriculum starts from the foundational level, and our instructors are experienced in guiding learners who have no prior exposure to financial markets. You do not need any background in finance or trading to apply.",
  },
  {
    q: "Do I need prior trading experience to enroll?",
    a: "No prior trading experience is required. We welcome learners at all stages of their financial education journey. Whether you are completely new to markets or have some exposure and want a more structured approach, our programs are designed to meet you where you are.",
  },
  {
    q: "Is the program available online or only in person?",
    a: "We offer both. Our Nairobi training center provides in-person classes, workshops, and coaching sessions for those who can attend locally. We also offer a full online learning experience for diaspora members and international learners who cannot be physically present in Nairobi. Both formats follow the same structured curriculum.",
  },
  {
    q: "Will there be coaching sessions and live workshops?",
    a: "Yes. Coaching and workshops are integral parts of our learning model. Students have access to live webinars, topic-specific workshops, and one-on-one or small group coaching sessions with experienced educators. These interactive elements are designed to reinforce learning and provide personalized guidance.",
  },
  {
    q: "How do I apply to the Trading Academy?",
    a: "You can apply by completing the inquiry and application form on this page. Our team will review your submission and reach out to discuss the right learning pathway for your goals. The process is straightforward and designed to be welcoming, not intimidating.",
  },
  {
    q: "Does the academy provide investment advice or manage funds?",
    a: "No. The Harambee Trading Academy is an educational institution. We provide structured financial education, market literacy training, and investor readiness support. We do not offer personalized investment advice, manage client funds, or make any guarantees about financial outcomes. All trading involves risk.",
  },
  {
    q: "What is the connection between the Trading Academy and Harambee Global Ventures?",
    a: "The Trading Academy is the educational flagship of Harambee Global Ventures, an international subsidiary of 7 Hills Development Group LLC. The academy is part of a broader platform that includes advisory services, family office support, and cross-border investment education &mdash; all focused on empowering the African Diaspora.",
  },
];

export default function AcademyFAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-5 gap-14">
        {/* Left */}
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            FAQ
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed mb-8">
            Have more questions? We are happy to help. Reach out to our team directly and we will get back to you promptly.
          </p>
          <a
            href="#apply"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-[#1A4D3C] text-white text-sm font-medium hover:bg-[#0D2E1E] transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Us <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* Right - Accordion */}
        <div className="lg:col-span-3 space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white border border-[#E8E4DC] rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer group"
              >
                <span className="font-medium text-[#2B2D2F] text-sm pr-4 group-hover:text-[#1A4D3C] transition-colors">
                  {faq.q}
                </span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#F8F6F3] flex-shrink-0">
                  <i className={`text-[#1A4D3C] text-base transition-transform duration-300 ${open === i ? "ri-subtract-line" : "ri-add-line"}`} />
                </div>
              </button>
              {open === i && (
                <div className="px-7 pb-6">
                  <p className="text-[#6B6B6B] text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: faq.a }} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
